import React from 'react';
import {observer} from 'mobx-react';
import TaskCompleted from 'shared/components/modals/task_modal/TaskCompleted';
import PerformanceReviewTask from 'shared/components/modals/task_modal/PerformanceReviewTask';
import PerformanceSurveyTask from 'shared/components/modals/task_modal/PerformanceSurveyTask';
import DocumentTask from 'shared/components/modals/task_modal/DocumentTask';
import TextDescriptionTask from 'shared/components/modals/task_modal/TextDescriptionTask';
import TrainingTask from 'shared/components/modals/task_modal/TrainingTask';
import OfferTask from 'shared/components/modals/task_modal/OfferTask';

function taskItem(task, uiState) {
  switch (task.taskType) {
    case 'reviewee':
      return <PerformanceReviewTask uiState={uiState}/>;
    case 'survey':
      return <PerformanceSurveyTask uiState={uiState}/>;
    case 'document':
      return <DocumentTask uiState={uiState}/>;
    case 'training':
      return <TrainingTask uiState={uiState}/>;
    case 'offer':
      return <OfferTask uiState={uiState}/>;
    case 'onboarding':
    case 'offboarding':
      return <TextDescriptionTask uiState={uiState}/>;
    default:
      return null;
  }
}

const TaskContentSwitch = observer(({uiState}) => {
  const {task} = uiState;

  return (
    <div>
      {taskItem(task, uiState)}
      {task.completed && <div className='mt2'><TaskCompleted uiState={uiState} /></div>}
    </div>
  );
});

const TaskContent = observer(({uiState}) => {
  const {task} = uiState;

  return (
    <div>
      <div className='h2 mb2'>{task.name}</div>
      <TaskContentSwitch uiState={uiState}/>
    </div>
  );
});

export default TaskContent;
